import React from 'react';
import { Card } from './ui/card';
import { OrderButton } from './OrderButton';

export const Portfolio = () => {
  const portfolioItems = [
    {
      title: "Custom Embroidered Sets",
      description: "Complete branded apparel sets including hoodies, hats, and beanies",
      image: "https://customer-assets.emergentagent.com/job_brand-consultation/artifacts/eal62xld_custom-embroidery.jpg",
      category: "Embroidery"
    },
    {
      title: "Professional Promotional Flags",
      description: "Eye-catching outdoor banners and promotional displays",
      image: "https://customer-assets.emergentagent.com/job_brand-consultation/artifacts/k6vdv5h4_flags-wow-avidbranding.png",
      category: "Promotional"
    },
    {
      title: "Custom Logo Design",
      description: "From concept to final product - complete branding solutions",
      image: "https://customer-assets.emergentagent.com/job_brand-consultation/artifacts/8n8afiy1_Screen%20Shot%202025-08-17%20at%203.35.21%20PM.png",
      category: "Design"
    },
    {
      title: "Quality Hat Construction",
      description: "Premium materials and professional finishing touches",
      image: "https://customer-assets.emergentagent.com/job_brand-consultation/artifacts/ryb8g1ky_Screen%20Shot%202025-02-08%20at%206.52.42%20PM.png",
      category: "Apparel"
    }
  ];

  return (
    <section id="portfolio" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Our <span className="text-blue-600">Work</span>
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            See the quality and craftsmanship that sets Avid Branding apart. 
            From custom embroidery to promotional materials, we deliver exceptional results.
          </p>
        </div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10">
          {portfolioItems.map((item, index) => (
            <Card key={index} className="overflow-hidden group hover:shadow-xl transition-all duration-300 border-2 border-blue-100 hover:border-blue-300">
              <div className="relative">
                <img 
                  src={item.image} 
                  alt={item.title}
                  className="w-full aspect-square object-cover rounded-2xl transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 text-white">
                  <span className="bg-blue-600 px-3 py-1 rounded-full text-sm font-semibold">
                    {item.category}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            </Card>
          ))}
        </div>

        <div className="text-center mb-16">
          <OrderButton
            label="Start Your Order"
            testid="portfolio-start-order-button"
            className="px-10 py-5 text-lg"
          />
        </div>

        {/* Special Promotion Section */}
        <div className="relative">
          <img 
            src="https://customer-assets.emergentagent.com/job_brand-consultation/artifacts/o6jer7cc_GIVEAWAY-PROMO-CUSTOM-TSHIRT-MUGS-YOUR-CUSTOMERS-AVIDBRANDING-2268502590.jpg"
            alt="Avid Branding promotional packages and giveaway items"
            className="w-full aspect-square object-cover rounded-2xl"
          />
          <div className="absolute inset-0 bg-black/40 rounded-2xl flex items-center justify-center">
            <div className="text-center text-white">
              <h3 className="text-3xl font-bold mb-4">Promotional Packages Available</h3>
              <p className="text-lg mb-6">Complete branded merchandise solutions for your business</p>
              <button 
                onClick={() => window.open('https://mail.google.com/mail/?view=cm&fs=1&to=communications@da-12.com&su=Promotional Package Inquiry', '_blank')}
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-200 mr-4"
              >
                Get Your Quote Today
              </button>
              <button
                onClick={() => window.open('https://preview.mailerlite.io/forms/1300492/164127746890400924/share', '_blank')}
                className="bg-teal-500 hover:bg-teal-600 text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-200"
              >
                📧 Subscribe to our mailout
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};